import './LocalesTable.css';

import React from 'react';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import { Checkbox } from '@mui/material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const LocalesTable = ({ locales, onUpdatedLocales }) => {
    const { t } = useB2BTranslation('b2b-sampling');

    const headers = [
        { label: t('Locale'), align: 'center' },
        { label: t('Language'), align: 'left' },
        { label: t('Selected'), align: 'center' },
    ];

    const handleCheckboxChange = (locale) => {
        const updatedLocales = locales.includes(locale) ?
            locales.filter((l) => l !== locale) :
            [...locales, locale];
        onUpdatedLocales(updatedLocales);
    }

    const rows = [
        {
            id: 'es', cells: [
                { content: 'es', align: 'center' },
                { content: t('Spanish'), align: 'left' },
                {
                    content: (
                        <Checkbox
                            checked={locales.includes('es')}
                            onChange={() => handleCheckboxChange('es')}
                        />
                    ),
                    align: 'center'
                }
            ]
        },
        {
            id: 'en', cells: [
                { content: 'en', align: 'center' },
                { content: t('English'), align: 'left' },
                {
                    content: (
                        <Checkbox
                            checked={locales.includes('en')}
                            onChange={() => handleCheckboxChange('en')}
                        />
                    ),
                    align: 'center'
                }
            ]
        },
        {
            id: 'ca', cells: [
                { content: 'ca', align: 'center' },
                { content: t('Catalan'), align: 'left' },
                {
                    content: (
                        <Checkbox
                            checked={locales.includes('ca')}
                            onChange={() => handleCheckboxChange('ca')}
                        />
                    ),
                    align: 'center'
                }
            ]
        },
        // {
        //     id: 'pt', cells: [
        //         { content: 'pt', align: 'center' },
        //         { content: t('Portuguese'), align: 'left' },
        //         {
        //             content: (
        //                 <Checkbox
        //                     checked={locales.includes('pt')}
        //                     onChange={() => handleCheckboxChange('pt')}
        //                 />
        //             ),
        //             align: 'center'
        //         }
        //     ]
        // },
        // {
        //     id: 'fr', cells: [
        //         { content: 'fr', align: 'center' },
        //         { content: t('French'), align: 'left' },
        //         {
        //             content: (
        //                 <Checkbox
        //                     checked={locales.includes('fr')}
        //                     onChange={() => handleCheckboxChange('fr')}
        //                 />
        //             ),
        //             align: 'center'
        //         }
        //     ]
        // }
    ]

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            className={'locales-table'}
            numRows={5}
            stickyHeader={true}
        />
    );
}

export default LocalesTable;